import { render } from "./removeSchedule.vue?vue&type=template&id=6e6a7108&ts=true"
import script from "./removeSchedule.vue?vue&type=script&lang=ts"
export * from "./removeSchedule.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__